import { carePlanTagApi } from "./care-plan-tag";

export const carePlanTagQueryKeys = {
  all: ["settings", "care-plan-tags"] as const,
  list: () => [...carePlanTagQueryKeys.all, "list"] as const,
};

export const carePlanTagQueryOptions = {
  list: () => ({
    queryKey: carePlanTagQueryKeys.list(),
    queryFn: () => carePlanTagApi.list(),
  }),
};
